export const MILESTONE_RESOURCE_ORDER = ['streak', 'stelline', 'learned_terms'];
export const MILESTONE_LABELS = { streak: 'giorni di fila!', stelline: 'stelline!', learned_terms: 'parole imparate!', daily_circuit: 'Circuito di oggi completato!' };
export const MILESTONE_SHARE_LABEL = 'Condividi il tuo traguardo';
export const dailyCircuitCopy = (event) => ({
  achievement: 'CIRCUITO COMPLETATO',
  caption: new Date(`${event.date}T00:00:00Z`).toLocaleDateString('it-IT', {
    day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC',
  }),
});
export const celebrationTheme = (event) => event.kind === 'daily_circuit' ? 'daily_circuit' : event.resource;
export const celebrationEventName = (event, action) => `${event.kind === 'daily_circuit' ? 'daily_circuit' : 'milestone'}_${action}`;
export const MILESTONE_THRESHOLDS = {
  streak: [7, 14, 30, 60, 90, 180, 365, 500, 1000],
  stelline: [500, 1000, 2500, 5000, 10000],
  learned_terms: [50, 100, 250, 500, 1000, 2500, 5000, 10000, 15000, 20000, 25000, 50000],
};
export const selectMilestone = (events = []) => [...events].sort((a, b) => (
  b.threshold - a.threshold
  || MILESTONE_RESOURCE_ORDER.indexOf(a.resource) - MILESTONE_RESOURCE_ORDER.indexOf(b.resource)
))[0] || null;
export const isValidMilestone = (event) => !!event && typeof event.id === 'string' && !!event.id
  && MILESTONE_THRESHOLDS[event.resource]?.includes(event.threshold)
  && Number.isInteger(event.value) && event.value >= event.threshold;
// Italian Intl defaults can omit grouping for four-digit numbers. Milestones
// consistently use the site's explicit 1.000 / 2.500 notation.
export const milestoneNumber = (event) => event.kind === 'daily_circuit'
  ? `${event.total}/${event.total}` : String(event.threshold).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
export const milestoneHeadline = (event) => {
  if (event.kind === 'daily_circuit') return `${milestoneNumber(event)} — ${MILESTONE_LABELS.daily_circuit}`;
  const number = milestoneNumber(event);
  if (event.resource === 'streak') return `${number} giorni di fila!`;
  if (event.resource === 'stelline') return `${number} stelline!`;
  return `${number} parole nel tuo percorso!`;
};
export const milestoneShareText = (event) => {
  const number = milestoneNumber(event);
  const achievement = event.kind === 'daily_circuit'
    ? `🏆 Ho completato tutti i giochi di oggi (${number})`
    : event.resource === 'streak'
    ? `🔥 Ho giocato per ${number} giorni di fila`
    : event.resource === 'stelline'
      ? `⭐ Ho raggiunto ${number} stelline questa settimana`
      : `📚 Ho raggiunto ${number} parole nel mio percorso`;
  return `${achievement} su Giochini di Parole! Giochi gratuiti per allenare l’italiano: provali anche tu.`;
};
export const milestoneShareUrl = (event, origin = window.location.origin) => {
  const url = new URL('/', origin);
  url.searchParams.set('utm_source', 'share');
  url.searchParams.set('utm_medium', 'milestone');
  url.searchParams.set('utm_campaign', event.kind === 'daily_circuit' ? 'daily_circuit' : `${event.resource}_${event.threshold}`);
  return url.toString();
};
